import { render } from "./CryptoFormDialog.vue?vue&type=template&id=2b40ddd9&scoped=true"
import script from "./CryptoFormDialog.vue?vue&type=script&lang=js"
export * from "./CryptoFormDialog.vue?vue&type=script&lang=js"

import "./CryptoFormDialog.vue?vue&type=style&index=0&id=2b40ddd9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b40ddd9"]])

export default __exports__